import {useState} from 'react';
import {Box, FormHelperText, Grid, InputLabel, Typography} from '@material-ui/core';
import {FormattedMessage, useIntl} from 'react-intl';
import messages from '@super-template/messages';
import {EditableInput, EditButton, FormFieldControl, FormInput} from './';
import getTranslated from '../locale/getTranslated';
import {Controller} from "react-hook-form";
import ReactHtmlParser from 'react-html-parser';
import {OverHundred} from "./index";

const emojiRegex = require('emoji-regex');
const enhanceValidation = (v, n) => ({
  ...v, validate: {
    ...v?.validate,
    no_emoji: (v) => !v.match(emojiRegex()),
    no_special: (v) => !v.includes('>') && !v.includes('<'),
    ...v?.no_decimal && {no_decimal: (v) => Number.isInteger(Number(v)) && !!v.match('^[0-9]\\d*$')},
    ...n && {no_negative: (v) => v >= 0}
  }
});

export default ({
                  name, isAdmin, control, fieldOptions = {}, isSmall, required, validate,
                  locale, placeholder, testId, ...props
                }) => {
  const intl = useIntl();
  const [editing, setEditing] = useState(false);
  const description = getTranslated(fieldOptions.description, locale, true);
  const title = getTranslated(fieldOptions.title, locale);

  return editing ? <EditableInput fieldOptions={fieldOptions} close={() => setEditing(false)} id={name}/> :
    <Controller
      control={control} name={name} defaultValue={''}
      rules={isAdmin ? {} : {...enhanceValidation(validate, props?.type === "number"), required}}
      render={({fieldState: {error}, field: {ref, ...field}}) =>
        <FormFieldControl fullWidth required={required} error={!!error}>
          <Box display="flex" justifyContent="space-between">
            <InputLabel shrink htmlFor={name}>
              {title}
              {props?.endAdornment && <Typography variant={"srOnly"}>{props.endAdornment}</Typography>}
            </InputLabel>
            {(validate?.maxLength && props?.type !== "number") &&
              <span style={{fontSize: 13, alignSelf: 'flex-end'}}>
              <FormattedMessage {...messages.maxLengthChars} values={{max: validate.maxLength}}/>
            </span>}
            {isAdmin && <EditButton onClick={() => setEditing(true)} isSmall={isSmall}/>}
          </Box>
          {description &&
            <FormHelperText component="div" id={`${name}_description`} className={'description'}>
              {ReactHtmlParser(description)}
            </FormHelperText>}
          <Grid container spacing={2}>
            <Grid item xs={12} sm={isSmall ? 6 : 12}>
              <FormInput
                fullWidth id={name} disabled={isAdmin} {...field} inputRef={ref} {...props} required={required}
                placeholder={placeholder ? placeholder === true ? intl.formatMessage(messages.leave_empty) : placeholder : ''}
                aria-describedby={`${name}${error ? '_help' : description ? '_description' : ''}`}/>
            </Grid>
          </Grid>
          {error &&
            <FormHelperText id={`${name}_help`}>
              <FormattedMessage {...messages[error.type]}
                                values={error.type === "maxLength" ? {cur: field?.value?.length} : {}}/>
            </FormHelperText>}
          {(!error && testId) && <OverHundred id={`${name}_help`} personId={field?.value}/>}
        </FormFieldControl>}
    />
};
